<p-table #dt [value]="atcList" [loading]="loading" dataKey="id" class="col-12 p-0">
  <ng-template pTemplate="header" *ngIf="level === 1">
    <tr>
      <th scope="expandable" [style.width.px]="65"></th>
      <th scope="code" [style.width.px]="150">{{screen.labels.code}}</th>
      <th scope="name">{{screen.labels.name}}</th>
      <th scope="parentCode" [style.width.px]="150">{{screen.labels.parentCode}}</th>
      <th scope="actions" [style.width.px]="65" *ngIf="isDoctor"></th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-atc let-expanded="expanded">
    <tr>
      <td [style.width.px]="65">
        <p-button type="button" [pRowToggler]="atc" styleClass="p-button-text p-button-rounded p-button-plain"
          [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'" *ngIf="atc.hasChildren"></p-button>
      </td>
      <td [style.width.px]="150">{{atc.id}}</td>
      <td class="text-ellipsis">{{atc.name}}</td>
      <td [style.width.px]="150">{{atc.parentId}}</td>
      <td [style.width.px]="65" *ngIf="isDoctor">
        <p-button type="button" styleClass="p-button-success p-button-rounded p-button-outlined"
          [pTooltip]="screen.actions.createAutocompletes" tooltipPosition="left" icon="fas fa-vial"
          [routerLink]="['/admin/general/atc', atc.id]">
        </p-button>
      </td>
    </tr>
  </ng-template>

  <ng-template pTemplate="rowexpansion" let-atc>
    <tr>
      <td colspan="4" class="p-0" *ngIf="isDoctor">
        <div ms-common-atc-exp-table [level]="atc.level + 1" [parent]="atc.id"></div>
      </td>
      <td colspan="5" class="p-0" *ngIf="isDoctor">
        <div ms-common-atc-exp-table [level]="atc.level + 1" [parent]="atc.id"></div>
      </td>
    </tr>
  </ng-template>
</p-table>